// LeSiam.IA - Client Web Theme
// Dark navy + gold palette matching staff dashboard

export const colors = {
  bg: '#0F0F23',
  card: '#1A1A3A',
  border: '#2A2A4A',
  inputBg: '#16213E',
  gold: '#C9A96E',
  goldLight: '#C9A96E20',
  text: '#F5F5F5',
  textMuted: '#A0A0A0',
  success: '#2ECC71',
  info: '#3498DB',
  purple: '#9B59B6',
  orange: '#E67E22',
  error: '#E74C3C',
  wine: '#722F37',
  wineLight: '#722F3720',
};

export const fonts = {
  body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif",
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
};

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
};

export const API_BASE = '/api/v1';
export const SOCKET_BASE = '/ws';